import SVG from "../SVG";

export const SliderBorder = (props: any) => {
  return (
    <SVG
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
        <path d="M12.6565 17C11.1107 18.2508 9.14243 19 6.99913 19C4.85583 19 2.88752 18.2508 1.3418 17M1.3418 3C2.88752 1.7492 4.85583 1 6.99913 1C9.14243 1 11.1107 1.7492 12.6565 3" stroke-linecap="round" stroke-linejoin="round"/>
    </SVG>
  );
};
